<template>
	<div>
		<div class="child-selector blain-form">
			<div class="visually-hidden">{{ selector.selectorLabel }} selector</div>
			<div v-if="isSelectList">
				<label :for="sizeSelectorId" class="cs-label display">
					<strong>{{ label }}</strong>
				</label>
				<select :id="sizeSelectorId" class="form-control child-selector" @change="selectListAttribute">
					<option v-if="!selectedAttribute" value="Select a size">
						Select {{ selector.selectorLabel.toLowerCase() }}...
					</option>
					<option
						v-for="att in selector.values"
						:key="att.value"
						:value="att.value"
						:selected="att.isSelected"
					>
						{{ att.value }}
						<span v-if="att.unavailable">
							(Unavailable with chosen option)
						</span>
					</option>
				</select>
			</div>
			<fieldset v-else class="select-area">
				<legend class="cs-label display">
					<strong>{{ label }}</strong>
				</legend>
				<child-selector-attribute
					v-for="att in selector.values"
					:attribute="att"
					:key="att.label"
					@change="selectAttribute(att)"
				/>
			</fieldset>
		</div>
	</div>
</template>

<script>
import ChildSelectorAttribute from "./ChildSelectorAttribute.vue";
export default {
	name: "ChildSelector",
	props: {
		selector: {
			type: Object,
			required: true
		},
	},
	components: { ChildSelectorAttribute },
	computed: {
		hasSwatches() {
			return this.selector.values.some(x => !!x.swatchUrl);
		},
		hasUnavailableSelected() {
			if (!this.selectedAttribute) return false;
			return this.selectedAttribute.unavailable;
		},
		isSelectList() {
			return this.selector.values.length > 10 && this.hasSwatches === false;
		},
		selectedAttribute() {
			return this.selector.values.find(x => x.isSelected);
		},
		sizeSelectorId() {
			return `childSelector-${this.selector.selector.replace(/\s/g, '')}`;
		},
		label() {
			let label = this.selector.selectorLabel;
			if (this.selectedAttribute) {
				label += `: ${this.selectedAttribute.value}`;
			}

			return label;
		}
	},
	methods: {
		selectListAttribute(e) {
			const val = e.target.value;
			const attribute = this.selector.values.find(x => x.value === val);
			this.$store.dispatch('selectAttribute', attribute);
		},
		selectAttribute(val) {
			this.$store.dispatch('selectAttribute', val);
		}
	},
};
</script>

<style lang="less" scoped>
@import '../../../less/_mixins.less';
.child-selector {
	margin: 15px 0;
	.cs-label {
		margin-bottom: 5px;
		.ms-styles({
			font-size: 14px;
		});
	}
	option span {
		font-size: 0.75%;
	}
}
.select-area {
	display: flex;
	align-items: center;
	// justify-content: end;
	justify-content: left;
	flex-wrap: wrap;
}
</style>